import script from "./CreateStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateStatus.vue?vue&type=script&setup=true&lang=js"

import "./CreateStatus.vue?vue&type=style&index=0&id=dd4633e2&scoped=true&lang=css"
import "./CreateStatus.vue?vue&type=style&index=1&id=dd4633e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd4633e2"]])

export default __exports__